import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import { clearSelectedFilters, fetchFilters, postUserVisit, setActiveActionCard } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import CheckBox from "components/common/Checkbox";
import CloseButton from "components/common/CloseButton";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import FilterCategories from "components/common/plans/FilterCategories";
import { isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { typography } from "styles/typography";
import { ENTER_KEY_CODE, PAGE_SIZE, minSearchStrLength } from "utils/CommonConstants";
import { getHoursAndMin } from "utils/CommonFunctions";
import { commonApiCallParam, isFunctionalArea, isLibraryPage } from "utils/UserAnalyticsUtils";
import { copyActionAsync, setImportExistingActionDialogDetails } from "../MyPlanDetails/MyPlanDetails.slice";
import { fetchIndividualActionAsync } from "../library/functionalArea/individualAction.slice";

const SumOfAction = (props: any) => {
  return (
    <>
      Add actions
      {props?.checkedAction.length ? (
        <Box
          sx={{
            height: "24px",
            width: "24px",
            borderRadius: "24px",
            backgroundColor: tokens.Primary.Primary400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "8px"
          }}
        >
          <Typography variant="body2">{props?.checkedAction.length}</Typography>
        </Box>
      ) : null}
    </>
  );
};

const ActionImportDialog = (props: any) => {
  const dispatch = useAppDispatch();
  const [pageNo, setPageNo] = useState(1);
  const [expanded, setExpanded] = useState(false);
  const { open, handleClose, setShowPreview } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [checkedAction, setCheckedAction] = useState<any[]>([]);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const filters = useAppSelector((state: any) => state.app.filters);
  const [filtersList, setFiltersList] = useState(filters);
  const filterIds = useAppSelector((state: any) => state.app.filterIds);
  const functionalAreas: any = useAppSelector((state) => state.functionalAreas.list);
  const targetPlanId = useAppSelector((state) => state.myPlanDetails.myPlanDetails.id);
  const totalRecords = useAppSelector((state: any) => state.individualAction.totalRecords);
  const individualActionList = useAppSelector((state: any) => state.individualAction.list);
  const { selectedTab: selectedImportExistingActionDialogTab, searchText } = useAppSelector(
    (state: any) => state.myPlanDetails.importExistingActionDialog
  );
  const activeCard = useAppSelector((state: any) => state.app.activeActionCard);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const libraryPlan = useAppSelector((state: any) => state.planDetails.planDetails);

  const dialogContentStyle = isMobileScreen
    ? {
        margin: "0px",
        padding: "0 16px",
        overflow: "auto"
      }
    : {
        margin: "0 32px",
        padding: "0",
        "-ms-overflow-style": "none",
        "scrollbar-width": "none",

        "&::-webkit-scrollbar": {
          display: "none"
        }
      };

  const getIndividualActions = (index: number, searchInput?: null | string, pageNo = 1) => {
    const props: any = {
      filter: {
        functionalAreaIds: [functionalAreas[index]?.id],
        filterIds,
        innCode
      },
      pagination: {
        page: pageNo,
        size: PAGE_SIZE
      },
      searchText: searchInput
    };
    dispatch(fetchIndividualActionAsync(props));
  };

  useEffect(() => {
    const selectedFilters = filters.filter(
      (item: any) => item.functionalAreaIds?.indexOf(functionalAreas[selectedImportExistingActionDialogTab]?.id) > -1
    );

    setFiltersList(selectedFilters);

    if (searchText) {
      getIndividualActions(selectedImportExistingActionDialogTab, searchText);
    } else {
      getIndividualActions(selectedImportExistingActionDialogTab);
    }

    setPageNo(1);
  }, [filters, selectedImportExistingActionDialogTab, filterIds]);

  useEffect(() => {
    getIndividualActions(0);
    dispatch(fetchFilters());
    setPageNo(1);
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(setImportExistingActionDialogDetails({ selectedTab: newValue, searchText: "" }));
    setCheckedAction([]);
    dispatch(clearSelectedFilters());
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, value: any) => {
    if (event.target.checked) {
      if (checkedAction.findIndex((element: any) => element?.id === value?.id) < 0) {
        setCheckedAction((prevState) => [...prevState, value]);
      }
    } else {
      setCheckedAction((prevState) => prevState.filter((item: any) => item?.id !== value?.id));
    }
  };

  const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setImportExistingActionDialogDetails({ searchText: event.target.value }));
  };

  const handleImportActions = () => {
    const payload = { cards: checkedAction };
    const url = { planId: targetPlanId, sectionId: props?.open };
    dispatch(copyActionAsync({ url, payload }));
    handleClose();
    dispatch(setImportExistingActionDialogDetails({ selectedTab: 0, searchText: "" }));
    dispatch(clearSelectedFilters());
  };

  const handleSearch = (e: any) => {
    if (e.keyCode === ENTER_KEY_CODE && e.target.value.trim().length > minSearchStrLength) {
      getIndividualActions(selectedImportExistingActionDialogTab, e.target.value);
    }
  };

  const fetchMore = () => {
    setPageNo((page) => page + 1);
    getIndividualActions(selectedImportExistingActionDialogTab, searchText, pageNo + 1);
  };

  const handleClearBtnPress = () => {
    if (searchText) {
      dispatch(setImportExistingActionDialogDetails({ searchText: "" }));
      getIndividualActions(selectedImportExistingActionDialogTab);
    }
  };

  const handleAreaChange = (newValue: number) => {
    setExpanded(false);
    dispatch(setImportExistingActionDialogDetails({ selectedTab: newValue, searchText: "" }));
    setCheckedAction([]);
    dispatch(clearSelectedFilters());
  };

  const handleCloseDialog = () => {
    dispatch(clearSelectedFilters());
    dispatch(setImportExistingActionDialogDetails({ selectedTab: 0, searchText: "" }));
    handleClose();
  };

  useEffect(() => {
    const selectedPlan = !isEmpty(selectedMyPlanDetail) ? selectedMyPlanDetail : libraryPlan;
    if (open && (isFunctionalArea() || !isEmpty(selectedPlan))) {
      const param = commonApiCallParam();
      if (isLibraryPage()) {
        param.cmsCardId = activeCard.id;
        param.cardTitle = activeCard.name;
        param.planName = selectedPlan.name;
        param.cmsPlanId = selectedPlan.id;
      } else if (!isFunctionalArea()) {
        param.planName = selectedPlan.name;
        param.cmsPlanId = selectedPlan.cmsPlanId;
        param.planId = selectedPlan.id;
        param.cmsCardId = activeCard.cmsCardId;
        param.cardId = activeCard.cardId;
        param.cardTitle = activeCard.name;
      } else {
        param.cmsCardId = activeCard.id;
        param.cardTitle = activeCard.name;
      }
      param.cardVisit = true;
      dispatch(postUserVisit(param));
    }
  }, [open, selectedMyPlanDetail, libraryPlan]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      fullScreen={isMobileScreen}
      open={open}
      onClose={(e, r) => {
        if (r !== "backdropClick") handleCloseDialog();
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: tokens.Background.General.Color,
          padding: isMobileScreen ? "16px 16px 24px" : "32px 32px 24px"
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          flexWrap={isMobileScreen ? "wrap-reverse" : "nowrap"}
        >
          <Grid item sx={{ width: "100%" }}>
            <Typography color={tokens.Text.General.PrimaryHeadline} showBold variant="h4">
              Import existing action
            </Typography>
          </Grid>
          <Grid item alignSelf="flex-end">
            <CloseButton handleClose={handleCloseDialog} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent sx={dialogContentStyle} id="actionItemsDivMobile">
        <Grid container alignItems="center" sx={{ padding: "30px 0" }}>
          <Grid item sx={{ marginRight: isMobileScreen ? "0" : "16px", flex: 1 }}>
            <TextField
              placeholder="Search by name"
              name="searchText"
              value={searchText}
              size="small"
              sx={isMobileScreen ? { width: "100%", marginBottom: "16px" } : { width: "50%", marginBottom: "0" }}
              onChange={handleSearchInputChange}
              onKeyDown={handleSearch}
              InputProps={{
                startAdornment: <SearchIcon />,
                endAdornment: searchText && (
                  <CloseIcon sx={{ cursor: "pointer" }} color="primary" onClick={handleClearBtnPress} />
                )
              }}
            />
          </Grid>
          <Grid
            item
            sx={{
              width: isMobileScreen ? "100%" : "25%",
              ".MuiFormControl-root": { minWidth: "100%" }
            }}
          >
            <FilterCategories openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} filters={filtersList} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item sx={{ flex: 1 }}>
            <Grid container alignItems="center" sx={{ marginBottom: isMobileScreen ? "16px" : "0", width: "100%" }}>
              <Grid item flex={isMobileScreen ? "0.5" : "1"}>
                <Typography
                  color={tokens.Text.General.Secondary}
                  variant="body1"
                  sx={{
                    border: isMobileScreen ? "none" : `1px solid ${tokens.Border.General.Tertiary}`,
                    borderWidth: "1px 0px 0px 0px",
                    padding: "16px 0",
                    paddingLeft: isMobileScreen ? "0" : "16px"
                  }}
                >
                  Functional area
                </Typography>
              </Grid>
              {isMobileScreen && (
                <Grid item flex="1" sx={{ marginLeft: "16px" }} onClick={() => setExpanded((prevState) => !prevState)}>
                  <Grid
                    container
                    sx={{
                      height: "56px",
                      padding: "18px 16px",
                      backgroundColor: tokens.Background.General.Color,
                      cursor: "pointer"
                    }}
                  >
                    <Grid item flex="1" sx={{ marginRight: "8px" }}>
                      <Typography variant="body2" sx={{ color: tokens.Text.General.Color }}>
                        {functionalAreas[selectedImportExistingActionDialogTab]?.name}
                      </Typography>
                    </Grid>
                    <Grid item>
                      {expanded ? (
                        <ExpandLessIcon sx={{ color: tokens.Text.General.Color }} />
                      ) : (
                        <ExpandMoreIcon sx={{ color: tokens.Text.General.Color }} />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>

            {isMobileScreen && (
              <Collapse in={expanded}>
                {functionalAreas.map((area: any, index: number) => (
                  <Typography
                    key={area.name}
                    variant="body2"
                    sx={{ padding: "16px", color: tokens.Text.General.PrimaryHeadline, cursor: "pointer" }}
                    onClick={() => handleAreaChange(index)}
                  >
                    {area?.name}
                  </Typography>
                ))}
              </Collapse>
            )}

            {!isMobileScreen && (
              <Tabs
                scrollButtons={false}
                variant="scrollable"
                visibleScrollbar
                orientation="vertical"
                value={selectedImportExistingActionDialogTab}
                onChange={handleTabChange}
                TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
                sx={{
                  maxHeight: "40vh"
                }}
              >
                {functionalAreas.map((tab: any, index: number) => (
                  <Tab
                    key={tab.name}
                    label={tab?.name}
                    sx={{
                      color:
                        selectedImportExistingActionDialogTab === index
                          ? tokens.Text.General.Color
                          : tokens.Text.General.PrimaryHeadline,
                      ...typography.body2,
                      alignItems: "flex-start",
                      textAlign: "left",
                      backgroundColor:
                        selectedImportExistingActionDialogTab === index
                          ? tokens.Background.General.Color
                          : "transparent",
                      marginRight: "8px",
                      "&.MuiTab-root:hover": {
                        backgroundColor: tokens.Background.General.Color,
                        color: tokens.Text.General.Color
                      }
                    }}
                  />
                ))}
              </Tabs>
            )}
          </Grid>
          <Grid item sx={{ width: isMobileScreen ? "100%" : "75%" }}>
            <Grid
              container
              alignItems="center"
              sx={{
                border: `1px solid ${tokens.Border.General.Tertiary}`,
                borderWidth: "1px 0px 0px 0px",
                padding: "16px 0"
              }}
            >
              <Grid item flex={1}>
                <Typography
                  color={tokens.Text.General.Secondary}
                  variant="body1"
                  sx={{
                    paddingLeft: isMobileScreen ? "0" : "16px"
                  }}
                >
                  Individual actions ({totalRecords})
                </Typography>
              </Grid>
            </Grid>

            <Box
              sx={
                isMobileScreen
                  ? {}
                  : {
                      maxHeight: "40vh",
                      overflowY: "auto"
                    }
              }
              id="actionItemsDiv"
            >
              {individualActionList.length ? (
                <Scroller
                  dataLength={individualActionList.length}
                  loadMore={fetchMore}
                  totalList={totalRecords}
                  label="Actions"
                  scrollableTarget={isMobileScreen ? "actionItemsDivMobile" : "actionItemsDiv"}
                >
                  {individualActionList.map((action: any) => (
                    <ActionItem
                      key={action?.id}
                      value={action}
                      setShowPreview={setShowPreview}
                      checked={checkedAction.findIndex((el: any) => el?.id === action?.id) >= 0}
                      onCheckboxChange={handleCheckboxChange}
                      isMobileScreen={isMobileScreen}
                    />
                  ))}
                </Scroller>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Typography variant="body2">No actions found</Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "24px 32px",
          border: `1px solid ${tokens.Border.General.Tertiary}`,
          borderWidth: "1px 0px 0px 0px",
          justifyContent: isMobileScreen ? "center" : "flex-end"
        }}
      >
        <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} />
        <Button
          disabled={checkedAction.length < 1}
          variant="primary"
          label={<SumOfAction checkedAction={checkedAction} />}
          onClick={handleImportActions}
        />
      </DialogActions>
    </Dialog>
  );
};

const ActionItem = (props: any) => {
  const dispatch = useAppDispatch();
  const { checked, onCheckboxChange, setShowPreview, value, isMobileScreen } = props;

  return (
    <Box
      sx={{
        margin: isMobileScreen ? "0 0 16px 0" : "16px 16px 0",
        borderBottom: `1px solid ${tokens.Border.General.Tertiary}`,
        paddingBottom: isMobileScreen ? "24px" : "0"
      }}
    >
      <Grid container>
        <Grid item xs={11} sx={{ marginBottom: "14px" }}>
          <Typography showBold variant="body1" color={tokens.Text.General.PrimaryHeadline}>
            {value?.name}
          </Typography>
        </Grid>
        <Grid item xs alignSelf="flex-start" textAlign="right">
          <CheckBox
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onCheckboxChange(e, value)}
            checked={checked}
            sx={{ padding: "0", margin: "0" }}
          />
        </Grid>
      </Grid>
      <Grid container alignItems="center" sx={{ paddingLeft: isMobileScreen ? "0" : "22px" }}>
        <Box sx={{ width: "64px" }}>
          <Timing variant="label" duration={getHoursAndMin(value?.timeEstimateMinutes)} />
        </Box>
        <Button
          sx={{ marginLeft: "18px" }}
          startIcon={<VisibilityIcon sx={{ marginRight: "-10px" }} />}
          height="10px"
          variant="text"
          label="Preview"
          size="Small"
          width="64px"
          onClick={() => {
            dispatch(setActiveActionCard(value));
            setShowPreview(true);
          }}
        />
      </Grid>
    </Box>
  );
};

export default ActionImportDialog;
